
import Vue from 'vue';

import { CvButton, CvButtonSet, CvInlineNotification } from '@carbon/vue';

export default Vue.extend({
  components: { CvButton, CvButtonSet, CvInlineNotification },
  props: {
    isAddEnabled: {
      type: Boolean,
      required: true,
    },
    isActionEdit: {
      type: Boolean,
      required: true,
    },
    isWarningShown: {
      type: Boolean,
      required: true,
    },
  },
});
